export default __webpack_public_path__ + "media/images/home-app-collect-c2055116.svg";